<div class="card-container">
  <mat-card class="card-content" id="reset-password_container">
    <mat-card-header>
      <img class="reset-password__logo" src="assets/images/header.png">
    </mat-card-header>
    <mat-card-content>
      <h3>{{'Reset Your Password' | translate}}</h3>
      <p>{{'Enter your user name and email address to receive instructions about how to reset your password.' | translate}}</p>
      <form [formGroup]="rpForm">
        <mat-form-field class="full-width">
          <mat-label>{{'Username' | translate}}</mat-label>
          <input class="form-control"
            formControlName="username" matInput
            type="text"/>
          @if (rpForm.get('username').errors?.required) {
            <mat-error>
              {{'Username is mandatory.' | translate}}
            </mat-error>
          }
        </mat-form-field>
        <br>
          <mat-form-field class="full-width">
            <mat-label>{{'Email' | translate}}</mat-label>
            <input class="form-control"
              formControlName="email" matInput  (keyup.enter)="send()"
              type="text"/>
            @if (rpForm.get('email').errors?.required) {
              <mat-error>
                {{'Email is mandatory.' | translate}}
              </mat-error>
            }
            @if (rpForm.get('email').errors?.validEmail) {
              <mat-error>
                {{'Please provide a valid email address.' | translate}}
              </mat-error>
            }
          </mat-form-field>

        </form>
        <mat-spinner [style.display]="loading ? 'block' : 'none'"></mat-spinner>
      </mat-card-content>
      <mat-card-actions class="actions">
        <button mat-flat-button (click)="cancel()">{{'Cancel' | translate}}</button>
        <button mat-flat-button color="primary" class="primary" [disabled]="!(rpForm.valid && rpForm.touched)"
          (click)="send()"
        >{{'Send' | translate}}</button>
      </mat-card-actions>
    </mat-card>
  </div>
